(() => {
  const loader = document.currentScript || document.querySelector('script[data-finder-src]');
  const section = document.querySelector('[data-v47-finder-section]');
  if (!loader || !section) return;
  let started = false;
  const load = () => {
    if (started) return;
    started = true;
    const script = document.createElement('script');
    script.src = loader.dataset.finderSrc;
    script.defer = true;
    script.onerror = () => { started = false; };
    document.head.append(script);
  };
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { load(); observer.disconnect(); }
    }, {rootMargin:'900px 0px'});
    observer.observe(section);
  } else { load(); }
  section.addEventListener('pointerenter', load, {once:true});
  section.addEventListener('focusin', load, {once:true});
})();